import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Loader2Icon } from 'lucide-react';
import { AdminDataProvider, useAdminData } from './contexts/AdminDataContext';
import { AdminShell } from './components/admin/AdminShell';
import { PublicSite } from './pages/PublicSite';
import { AdminLogin } from './pages/admin/AdminLogin';
import { Overview } from './pages/admin/Overview';
import { Enquiries } from './pages/admin/Enquiries';
import { Quotes } from './pages/admin/Quotes';
import { QuoteNew } from './pages/admin/QuoteNew';
import { QuoteDetail } from './pages/admin/QuoteDetail';
import { Cases } from './pages/admin/Cases';
import { CaseNew } from './pages/admin/CaseNew';
import { CaseDetail } from './pages/admin/CaseDetail';
import { Customers } from './pages/admin/Customers';
import { CustomerDetail } from './pages/admin/CustomerDetail';
import { Settings } from './pages/admin/Settings';
import { company } from './data/site';
import { applyBrandIcon } from './utils/favicon';
import { initAnalytics } from './utils/analytics';
function RequireAdmin({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    loggedIn,
    authLoading
  } = useAdminData();
  if (authLoading) {
    return <div className="flex min-h-screen w-full items-center justify-center bg-canvas" data-id="element-0" data-mp="3rcsxpt9jqcdw">
        <p className="flex items-center gap-2 text-[15px] text-ink-muted" data-id="element-1" data-mp="4wylxj0jajy">
          <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-2" data-mp="2zllcouynw8jk" />
          Henter …
        </p>
      </div>;
  }
  if (!loggedIn) return <Navigate to="/admin/login" replace data-id="element-3" data-mp="33mykhalbelt4" />;
  return <>{children}</>;
}
export function App() {
  useEffect(() => {
    applyBrandIcon(company.logoMark, 'Lykkeværk');
    void initAnalytics();
  }, []);
  return <AdminDataProvider data-id="element-4" data-mp="3dirw8rr7mb9u">
      <BrowserRouter data-id="element-5" data-mp="nvsvh92bsvy2">
        <Routes data-id="element-6" data-mp="nwc0jp6vnpuo">
          <Route path="/" element={<PublicSite data-id="element-8" data-mp="nvan5e2e2r9s" />} data-id="element-7" data-mp="nur948fv0n11" />
          <Route path="/admin/login" element={<AdminLogin data-id="element-10" data-mp="stko65asom3b" />} data-id="element-9" data-mp="sunfgec14qjr" />
          <Route path="/admin" element={<RequireAdmin data-id="element-12" data-mp="35glr3hkw7k1">
                <AdminShell data-id="element-13" data-mp="34nbhsjeuzx5" />
              </RequireAdmin>} data-id="element-11" data-mp="sssr0q1jugax">
            <Route index element={<Overview data-id="element-15" data-mp="3ucj91juaptoz" />} data-id="element-14" data-mp="3ubztuaw15jen" />
            <Route path="henvendelser" element={<Enquiries data-id="element-17" data-mp="d3mkjc838xko" />} data-id="element-16" data-mp="d4nuteha5g1c" />
            <Route path="tilbud" element={<Quotes data-id="element-19" data-mp="85l30vqb96bb" />} data-id="element-18" data-mp="d3wcv6glvgtj" />
            <Route path="tilbud/ny" element={<QuoteNew data-id="element-21" data-mp="864b7kq5sgc5" />} data-id="element-20" data-mp="85bbv4tj4t41" />
            <Route path="tilbud/:quoteId" element={<QuoteDetail data-id="element-23" data-mp="3gkla21uate6j" />} data-id="element-22" data-mp="83qhpgb4nc6p" />
            <Route path="sager" element={<Cases data-id="element-25" data-mp="3gj1ru5p30t24" />} data-id="element-24" data-mp="3glwbvw46obv0" />
            <Route path="sager/ny" element={<CaseNew data-id="element-27" data-mp="3bnmh3mmdfd9x" />} data-id="element-26" data-mp="3bmjo995hn0rd" />
            <Route path="sager/:caseId" element={<CaseDetail data-id="element-29" data-mp="3qaxtfqqdn1b3" />} data-id="element-28" data-mp="3bo4j6zvpslpr" />
            <Route path="kunder" element={<Customers data-id="element-31" data-mp="3qcin7e4vag7w" />} data-id="element-30" data-mp="3qc950cq2ddcr" />
            <Route path="kunder/:customerId" element={<CustomerDetail data-id="element-33" data-mp="3ljfzhmmru0zm" />} data-id="element-32" data-mp="3lkhf84eqfbno" />
            <Route path="indstillinger" element={<Settings data-id="element-35" data-mp="2xudb7vxmt9w5" />} data-id="element-34" data-mp="3liedwo84pw3n" />
          </Route>
          <Route path="*" element={<Navigate to="/" replace data-id="element-37" data-mp="2xsk30c7dehm1" />} data-id="element-36" data-mp="2xtc05rgm8nef" />
        </Routes>
      </BrowserRouter>
    </AdminDataProvider>;
}